import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ChangeRequestsPage } from '@/features/owner/change-requests-page';

const searchSchema = z.object({
  cr: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/decisions/change-requests')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <ChangeRequestsPage projectId={projectId} focus={search.cr} />;
}
